'use strict';

let isLoggingOut = false;
const listeners = new Set();

export const getIsLoggingOut = () => isLoggingOut;

export const setIsLoggingOut = (nextValue) => {
	const next = Boolean(nextValue);
	if (next === isLoggingOut) {
		return;
	}
	isLoggingOut = next;
	listeners.forEach((listener) => {
		try {
			listener();
		} catch (error) {
			// Ignore listener errors to avoid breaking state updates.
		}
	});
};

export const subscribeIsLoggingOut = (listener) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

